import { GQL_EXCHANGE_TYPE } from "@/shared/Disclosure/types/GQL/enum/ExchangeType";
import { PV_DISCLOSURE_PAGE } from "@/types/PresenterModel/PV_DISCLOSURE_PAGE";
import { API_REQ_DISCLOSURE_LIST } from "@/types/apiModel/Disclosure/API_REQ_DISCLOSURE_LIST";
import {
  API_RES_DISCLOSURE_USA,
  API_RES_USA_LIST_ITEM
} from "@/types/apiModel/Disclosure/API_RES_DISCLOSURE_USA";
import createGraphqlClient from "@/utils/createGraphqlClient";
import { gql } from "graphql-request";
import { isDisclosureListItem } from "../common/isDisclosureListItem";
import commonQueryFilter from "../common/commonQueryFilter";
import { PV_DISCLOSURE_ITEM } from "@/types/PresenterModel/PV_DISCLOSURE_ITEM";
import parseItem from "./parseUSAListItem";

const exchangeType = GQL_EXCHANGE_TYPE.USA;

const query = (p: API_REQ_DISCLOSURE_LIST, limit?: number) => gql`
query disclosureListUSA {
  getDisclosure(
    filter: {
    ${commonQueryFilter(p, limit)}
  }) {
      id
      dataDate
      korName
      details {
        ... on USA {
          secName
          secCode
          mainUrl
          categoryId
          eventLabel
          exchangeLabel
          analysisDEF14A {
            proposalKorList
          }
          analysisForm10s {
            businessOverviewKor
            businessOverviewShortKor
            riskJSONKor
            legalJSONKor
            repurchaseKor
            financeEarningKor
            financeLiquidityKor
            financeEquityKor
            financeOthersKor
          }
        }
      }
      analysisDetails {
        topicKor
        summarizeTinyKor
        summarizeLongKor
      }
    }
  }
`;

export async function parse(
  list: API_RES_USA_LIST_ITEM[]
): Promise<PV_DISCLOSURE_ITEM[]> {
  return (await Promise.all((list || []).map(parseItem))).filter(
    isDisclosureListItem
  );
}

async function parser(
  data: API_RES_DISCLOSURE_USA,
  pageNumber: number
): Promise<PV_DISCLOSURE_PAGE> {
  return {
    list: await parse(data?.getDisclosure),
    pageNumber,
    exchangeType
  };
}

export async function reqUSADisclosureList(
  p: API_REQ_DISCLOSURE_LIST,
  limit?: number
) {
  const client = createGraphqlClient();
  return parser(await client.request(query(p, limit)), p.page);
}
